var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/
var is_node = !!(typeof module == 'object' && module.exports);
define(['hola_pub_util', '/util/ajax.js', '/util/etask.js', 'lodash'], function (hola_pub_util, ajax, etask, _) {
  var E = {};

  // -- api calls --

  E.get_payment_conf = function (cname, pmethod) {
    return ajax.get(E.base_url + '/payment_conf', {
      qs: {
        customer: cname,
        pmethod: pmethod
      },
      slow: E.ajax_slow
    });
  };
  E.get_session_id = function () {
    return ajax({
      url: E.base_url + '/session_id',
      method: 'POST'
    });
  };
  E.ajax = function (method, path, opt) {
    opt = Object.assign({
      method: method,
      url: (path.startsWith('/') ? E.base_url : '') + path,
      json: 1,
      slow: E.ajax_slow,
      timeout: 60000,
      retry: 3,
      should_retry: E.ajax_should_retry
    }, opt);
    if (!{
      get: 1,
      delete: 1
    }[opt.method.toLowerCase()] && opt.data != null && typeof opt.data != 'string') {
      opt.content_type = opt.content_type || 'application/json';
      if (opt.content_type.startsWith('application/json')) opt.data = JSON.stringify(opt.data);
    }
    return ajax(opt);
  };
  E.base_url = '/users/pay';
  if (!is_node) E.base_url = window.location.protocol + '//' + window.location.host + E.base_url;
  E.ajax_slow = 8000;
  E.ajax_should_retry = function (err, xhr) {
    return xhr.status > 500;
  };

  // -- rendering --

  E.load_script = function (url, field, on_err) {
    return etask([function () {
      var script_el = document.createElement('script');
      var continue_fn = this.continue_fn();
      var start = Date.now();
      script_el.onload = function () {
        if (url.includes('js.stripe.com')) {
          hola_pub_util.perr({
            id: 'www_stripe_load_dur',
            info: {
              dur: (Date.now() - start) / 1000,
              ready: !!window.Stripe
            }
          });
        }
        continue_fn(field ? window[field] : window);
      };
      script_el.src = url;
      if (on_err) script_el.onerror = on_err;
      document.body.appendChild(script_el);
      return this.wait();
    }]);
  };
  E.add_class = function (el, v) {
    var classes = (el.className || '').split(/\s+/).filter(Boolean);
    if (classes.indexOf(v) == -1) classes.push(v);
    E.set_classes(el, classes);
  };
  E.remove_class = function (el, v) {
    var classes = (el.className || '').split(/\s+/).filter(Boolean);
    _.pull(classes, v);
    E.set_classes(el, classes);
  };
  E.toggle_class = function (el, v, toggle) {
    var classes = (el.className || '').split(/\s+/).filter(Boolean);
    if (!toggle) _.pull(classes, v);else if (classes.indexOf(v) == -1) classes.push(v);
    E.set_classes(el, classes);
  };
  E.set_classes = function (el, v) {
    if (Array.isArray(v)) v = v.join(' ');
    if (el.className != v) el.className = v;
  };
  E.has_class = function (el, v) {
    var classes = (el.className || '').split(/\s+/).filter(Boolean);
    return classes.includes(v);
  };

  // -- general utils --

  E.report_error = function (id, error, context) {
    console.error(error);
    hola_pub_util.perr({
      id: 'www_pay_' + id,
      info: {
        error: {
          message: error.message,
          stack: (error.stack || '').split('\n').map(function (v) {
            return _.trim(v);
          }).filter(function (v) {
            return v && v.startsWith('at ');
          })
        },
        context: context
      }
    });
  };
  E.to_array = function (v) {
    if (v == null) return [];
    if (!Number.isFinite(v.length) || typeof v == 'string') return [v];
    return Array.prototype.slice.call(v);
  };
  E.cached_etask_fn = function (opt) {
    if (typeof opt == 'function') opt = {
      fn: opt
    };
    var reset_cnt = 0,
      cur_args_id,
      et,
      result;
    var _wrapper_fn = function wrapper_fn() {
      var args = Array.prototype.slice.call(arguments);
      var args_id = opt.args_id && opt.args_id.apply(null, args) || 'default';
      if (cur_args_id && cur_args_id != args_id) _wrapper_fn.reset();
      if (cur_args_id && !et) return etask([function () {
        return result;
      }]);
      if (cur_args_id && et) return etask([function () {
        return this.wait_ext(et);
      }]);
      cur_args_id = args_id;
      var reset_cnt_snapshot = reset_cnt;
      return et = etask([function () {
        this.finally(function () {
          et = null;
        });
        return opt.fn.apply(null, args);
      }, function (res) {
        if (reset_cnt == reset_cnt_snapshot) result = res;
        return res;
      }]);
    };
    _wrapper_fn.reset = function () {
      cur_args_id = et = result = null;
      reset_cnt++;
    };
    return _wrapper_fn;
  };

  // -- basic utils --

  E.ensure_customer_name = function (v) {
    if (v == null || typeof v == 'string') return v;
    if (typeof v.customer == 'string') return v.customer;
    return v.name || v.customer_name;
  };
  E.check_required_params = function (params, required) {
    var missing = required.filter(function (k) {
      return params[k] == null;
    });
    if (missing.length) throw new Error('Missing params: ' + missing.join(', '));
  };
  E.prune_obj = function (obj) {
    return (_.pickBy || _.pick)(obj, function (v) {
      return v != null;
    });
  };
  E.split_name = function split_name(val) {
    var parts = ('' + val).split(/\s+/);
    return [parts.shift(), parts.join(' ')];
  };
  return E;
});